export const THEME = {
    colors: {
        primary: '#ffcc1c',
        secondary: '#1a1a1a',
        accent: '#FF6B6B',
        background: '#ffffff',
        text: {
            primary: '#1a1a1a',
            secondary: '#666666',
            light: '#888888'
        },
        gradients: {
            yellow: 'linear-gradient(135deg, #FFCA18 0%, #FFB800 100%)',
            blue: 'linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)',
            green: 'linear-gradient(135deg, #34D399 0%, #059669 100%)'
        },
        hover: {
            yellow: 'linear-gradient(135deg, #FFD44F 0%, #FFC233 100%)',
        }
    },
    shadows: {
        card: '0 4px 24px rgba(0,0,0,0.06)',
        yellow: '0 4px 24px rgba(255,204,28,0.2)',
        hover: '0 8px 32px rgba(0,0,0,0.12)'
    },
    spacing: {
        section: '3rem',
        element: '1.5rem',
        headerOffset: '64px'
    },
    borderRadius: {
        sm: '8px',
        md: '12px',
        lg: '16px'
    }
};